import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";
import { fontMerriweather, fontRoboto } from "@product/scmp-sdk";

import {
  ArticleImageContainer,
  DescriptionContainer as ArticleImageDescriptionContainer,
  ImageContainer as ArticleImageWrapper,
} from "scmp-app/components/article/article-image/styles";
import { Container as BlockQuoteContainer } from "scmp-app/components/article/article-render/print-article/blockquote-quote/styles";
import { Container as DataWrapperIframeContainer } from "scmp-app/components/schema-render/common/iframe/data-wrapper/styles";
import { Container as IframeContainer } from "scmp-app/components/schema-render/common/iframe/generic-iframe/styles";
import { StyledContainer as TableContainer } from "scmp-app/components/schema-render/common/table/styles";

type Props = {
  theme: Theme;
};

export const pageStyle = (props: Props) => css`
  color: #000000;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontMerriweather};
  line-height: 16.8px;

  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;

  & > * {
    margin-block-end: 16px;
  }

  *::selection {
    background: #cdd8e5;
  }

  a {
    color: #222222;
    font-weight: 400;
    text-decoration: none;

    > span {
      border-block-end: 1px solid #4585ff;

      word-break: break-word;

      &:hover {
        border-block-end: none;
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-block: inherit;

    font-weight: 700;
    font-family: ${fontRoboto};
  }

  h1,
  h2,
  h3 {
    padding-block: 10px 0;

    font-size: 16px;
    line-height: 18.75px;
  }

  h4,
  h5,
  h6 {
    padding-block: 10px 2px;
    padding-inline: 0;

    font-size: 12px;
    line-height: 14px;
  }

  h3 {
    :empty {
      display: none;
    }
  }

  ol {
    list-style: decimal;
  }

  ul {
    list-style: disc;
  }

  li {
    margin-inline-start: 12px;
    padding-block-end: 0;
    padding-inline-start: 2px;

    &:not(:last-child) {
      padding-block-end: 16px;
    }
    * {
      margin: 0 !important;
    }
  }

  strong {
    font-weight: 700;
  }

  ${BlockQuoteContainer} {
    max-inline-size: 800px;
    padding-inline-end: 80px;
  }

  ${DataWrapperIframeContainer},
  ${IframeContainer},
  ${TableContainer} {
    max-inline-size: 360px;
  }

  ${ArticleImageContainer} {
    display: flex;

    max-inline-size: 700px;
    margin: 0;
    padding-block: 12px;

    ${props.theme.breakpoints.only("mobile")} {
      position: unset;
      inset-inline: unset;

      inline-size: unset;
      margin-inline: unset;
    }

    ${ArticleImageWrapper} {
      max-inline-size: 160px;
      & > img {
        max-inline-size: 100%;
      }
    }

    ${ArticleImageDescriptionContainer} {
      max-inline-size: 400px;
      margin-block-start: 0;
      margin-inline-start: 12px;
      padding-inline: 0;

      color: #000000;
      font-size: 10px;
      line-height: 11.7px;
    }
  }
`;
